import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchPlansRequest,
  fetchPlansSuccess,
  fetchPlansFailure,
  createPlanRequest,
  fetchAppSubscriptionRequest,
  fetchAppSubscriptionSuccess,
  fetchAppSubscriptionFailure,
  createPlanSuccess,
  createPlanFailure,
  updatePlanRequest,
  updatePlanSuccess,
  updatePlanFailure,
  deletePlanRequest,
  deletePlanSuccess,
  deletePlanFailure,
  purchasePlanRequest,
  purchasePlanSuccess,
  purchasePlanFailure,
  checkPaymentStatusRequest,
  checkPaymentStatusSuccess,
  checkPaymentStatusFailure,
  checkActivePlanRequest,
  checkActivePlanSuccess,
  checkActivePlanFailure,
  checkButtonRequest,
  purchaseDirectPlan,
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
  manuallyExpireSubscriptionRequest,
  manuallyExpireSubscriptionSuccess,
  manuallyExpireSubscriptionFailure,
  payInstallmentRequest,
  payInstallmentSuccess,
  payInstallmentFailure,
  fetchChildSubscriptionRequest,
  fetchChildSubscriptionSuccess,
  fetchChildSubscriptionFailure,
  payExternalFeaturesRequest,
  payExternalFeaturesSuccess,
  payExternalFeaturesFailure,
  fetchExternalSubscriptionRequest,
  fetchExternalSubscriptionSuccess,
  fetchExternalSubscriptionFailure,
  updateBenefitAndFeatureRequest,
  updateBenefitAndFeatureSuccess,
  updateBenefitAndFeatureFailure,
} from "./SubscriptionSlice";

// GET ALL PLANS
function* fetchPlansWorker(action) {
  try {
    const { search, page, limit } = action.payload || {};
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/getJewellerSubscriptionList`,
      {
        params: {
          ...(search && { search }),
          ...(page && { page }),
          ...(limit && { limit }),
        },
      },
    );
    console.log("response.data.data, in paln", response.data.data);
    yield put(
      fetchPlansSuccess({
        data: response.data.data,
        total: response.data.total,
      }),
    );
  } catch (error) {
    yield put(fetchPlansFailure(error.message));
    toast.error("Failed to load subscription plans");
  }
}

// GET All App Subscriptions
function* fetchAppSubscriptionWorker(action) {
  try {
    const { search, page, limit } = action.payload || {};
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/getJewellerAppSubscriptionList`,
      {
        params: {
          search,
          page,
          limit,
        },
      },
    );
    console.log("response.data.data,", response.data.data);
    yield put(
      fetchAppSubscriptionSuccess({
        data: response.data.data,
        total: response.data.total,
      }),
    );
  } catch (error) {
    yield put(fetchAppSubscriptionFailure(error.message));
    toast.error("Failed to load app subscription plans");
  }
}
// CREATE PLAN
function* createPlanWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/createJewellerSubscription`,
      action.payload,
    );
    if (response.data.success) {
      toast.success(response.data.message);
      yield put(fetchPlansRequest());
      return;
    }
    toast.error(response.data.message);
  } catch (error) {
    yield put(createPlanFailure(error.message));
    toast.error("Failed to create subscription plan");
  }
}

// PURCHASE PLAN
function* purchasePlanWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/purchaseJewellerSubscription`,
      action.payload,
    );
    if (response.data.success) {
      window.open(
        `/cashfree/${response.data.data.token}/${response.data.data.orderId}`,
        "_self",
      );
      // yield put(purchasePlanSuccess(response.data.data))

      return;
    }
    toast.error(response.data.message);
  } catch (error) {
    toast.error(
      "Failed to purchase/upgrade subscription plan, Kindly contact administrator",
    );
  }
}

// UPDATE PLAN
function* updatePlanWorker(action) {
  try {
    //   const { _id, ...updateData } = action.payload;
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/updateJewellerSubscription`,
      action.payload,
    );
    if (response.data.success) {
      toast.success(response.data.message);
      yield put(fetchPlansRequest());
      return;
    }
    toast.error(response.data.message);
  } catch (error) {
    yield put(updatePlanFailure(error.message));
    toast.error("Failed to update subscription plan");
  }
}

// DELETE PLAN
function* deletePlanWorker(action) {
  try {
    yield call(
      axios.delete,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription-plans/${action.payload}`,
    );
    yield put(deletePlanSuccess(action.payload));
    toast.success("Subscription plan deleted successfully");
  } catch (error) {
    yield put(deletePlanFailure(error.message));
    toast.error("Failed to delete subscription plan");
  }
}
function* checkPaymentStatusWorker(action) {
  const { orderId } = action.payload;
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/checkJewellerSubscriptionPaymentStatus/${orderId}`,
    );
    if (response.data.success) {
      toast.success("Subscription plan has been added successfully");
      window.open("/Subscription", "_self");
      return;
    } else {
      toast.error(response.data.message);
      window.open("/Subscription", "_self");
      return;
    }
  } catch (error) {
    yield put(checkPaymentStatusFailure(error.message));
    toast.error("Failed to check payment status");
  }
}
function* checkActivePlanWOrker() {
  const response = yield call(
    axios.get,
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/getActiveJewellerSubscription`,
  );
  if (response.data.success) {
    yield put(checkActivePlanSuccess(response.data.data));
  }
}
function* checkButtonRequestWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer/button`,
      action.payload,
    );
    if (response.data.success) {
      toast.success(response.data.message);
      //  yield put(fetchPlansRequest());
      return;
    }
    toast.error(response.data.message);
  } catch (error) {
    //yield put(createPlanFailure(error.message));
    toast.error("Failed to create subscription plan");
  }
}

// PURCHASE DIRECT  PLAN
function* purchaseDirectPlanWorker(action) {
  try {
    //   const { _id, ...updateData } = action.payload;
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/createDirectJewellerAppSubscription`,
      action.payload,
    );

    if (response.data.success) {
      toast.success(response.data.message);
      yield put(fetchAppSubscriptionRequest());
      return;
    }

    toast.error(response.data.message);
  } catch (error) {
    toast.error("Failed to create subscription plan");
  }
}

function* fetchSubscriptionSaga(action) {
  try {
    const {
      start = 0,
      limit = 10,
      search = "",
      status = "Active",
    } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/getAllJewellerSubscription`,
        {
          params: {
            start,
            limit,
            search,
            status,
          },
        },
      ),
    );

    const resData = response.data;

    if (resData.success) {
      const subscriptions = resData.data?.data || [];
      const total = resData.data?.total || 0;

      yield put(
        fetchSubscriptionSuccess({
          subscriptions,
          total,
          message: resData.message,
        }),
      );
    } else {
      yield put(fetchSubscriptionFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchSubscriptionFailure(error.message));
  }
}

function* manuallyExpireSubscriptionWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/expiredSubscription`,
      action.payload,
    );

    if (response.data.success) {
      toast.success(response.data.message);

      yield put(manuallyExpireSubscriptionSuccess());

      // refresh list
      yield put(fetchAppSubscriptionRequest());

      return;
    }

    toast.error(response.data.message);
  } catch (error) {
    yield put(manuallyExpireSubscriptionFailure(error.message));
    toast.error("Failed to expire subscription plan");
  }
}

function* payInstallmentWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/payInstallment`,
      action.payload,
    );

    const resData = response.data;

    if (resData.success) {
      toast.success(resData.message || "Installment paid successfully");

      yield put(payInstallmentSuccess(resData.data));
      yield put(fetchAppSubscriptionRequest());

      return;
    }

    toast.error(resData.message || "Payment failed");
    yield put(payInstallmentFailure(resData.message));
  } catch (error) {
    yield put(payInstallmentFailure(error.message));
    toast.error("Failed to pay installment");
  }
}

function* fetchChildSubscriptionWorker(action) {
  try {
    const { parentId } = action.payload;

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/children/${parentId}`,
    );

    const resData = response.data;

    if (resData.success) {
      yield put(
        fetchChildSubscriptionSuccess({
          data: resData.data || [],
          total: resData.data?.length || 0,
        }),
      );
      return;
    }

    yield put(fetchChildSubscriptionFailure(resData.message));
    toast.error(resData.message);
  } catch (error) {
    yield put(fetchChildSubscriptionFailure(error.message));
    toast.error("Failed to fetch child subscriptions");
  }
}

function* payExternalFeaturesWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/payExternalFeatures`,
      action.payload,
    );

    const resData = response.data;

    if (resData.success) {
      toast.success(resData.message || "External features added successfully");
      yield put(payExternalFeaturesSuccess(resData.data));
      yield put(fetchAppSubscriptionRequest()); // refresh list
      return;
    }

    toast.error(resData.message || "Failed to add external features");
    yield put(payExternalFeaturesFailure(resData.message));
  } catch (error) {
    yield put(payExternalFeaturesFailure(error.message));
    toast.error("Failed to add external features");
  }
}

function* updateBenefitAndFeatureWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/updateBenefitAndFeature`,
      action.payload,
    );

    const resData = response.data;

    if (resData.success) {
      const body =
        resData.data && typeof resData.data === "object" && !Array.isArray(resData.data)
          ? resData.data
          : {};
      const isPlanObject = (value) =>
        Boolean(
          value &&
            typeof value === "object" &&
            !Array.isArray(value) &&
            (value.planName || value.features || value.benefits),
        );
      const responsePlan =
        [body.plan, body.jewellerSubscription, body.subscription, body].find(
          isPlanObject,
        ) || null;
      const updatedCount =
        body.updatedCount ??
        body.updatedAppSubscriptions ??
        body.appSubscriptionsUpdated ??
        body.appSubscriptionUpdated ??
        body.modifiedCount ??
        resData.updatedCount;

      const plan = {
        _id: action.payload._id,
        ...(responsePlan || {}),
        features: responsePlan?.features ?? action.payload.features,
        benefits: responsePlan?.benefits ?? action.payload.benefits,
      };

      toast.success(
        resData.message ||
          `Benefits and features updated${
            updatedCount != null
              ? `. ${updatedCount} app subscriptions updated`
              : ""
          }`,
      );

      yield put(
        updateBenefitAndFeatureSuccess({
          plan,
          updatedCount,
          token: Date.now(),
        }),
      );
      yield put(fetchPlansRequest({ page: 1, limit: 500 }));
      return;
    }

    toast.error(resData.message || "Failed to update benefits and features");
    yield put(updateBenefitAndFeatureFailure(resData.message));
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(updateBenefitAndFeatureFailure(message));
    toast.error(message || "Failed to update benefits and features");
  }
}

function* fetchExternalSubscriptionWorker(action) {
  try {
    const { subscriptionId, jewellerId } = action.payload;

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/subscription/getExternalSubscription/${subscriptionId}`,
      {
        params: {
          jewellerId,
        },
      },
    );

    const resData = response.data;

    if (resData.success) {
      yield put(
        fetchExternalSubscriptionSuccess({
          data: resData.data || [],
        }),
      );
      return;
    }

    yield put(fetchExternalSubscriptionFailure(resData.message));
    toast.error(resData.message);
  } catch (error) {
    yield put(fetchExternalSubscriptionFailure(error.message));
    toast.error("Failed to fetch external subscription");
  }
}
export function* watchSubscriptionPlanSaga() {
  yield takeLatest(fetchPlansRequest.type, fetchPlansWorker);
  yield takeLatest(createPlanRequest.type, createPlanWorker);
  yield takeLatest(updatePlanRequest.type, updatePlanWorker);
  yield takeLatest(deletePlanRequest.type, deletePlanWorker);
  yield takeLatest(purchasePlanRequest.type, purchasePlanWorker);
  yield takeLatest(checkPaymentStatusRequest.type, checkPaymentStatusWorker);
  yield takeLatest(checkActivePlanRequest.type, checkActivePlanWOrker);
  yield takeLatest(checkButtonRequest.type, checkButtonRequestWorker);
  yield takeLatest(
    fetchAppSubscriptionRequest.type,
    fetchAppSubscriptionWorker,
  );
  yield takeLatest(purchaseDirectPlan.type, purchaseDirectPlanWorker);
  yield takeLatest(fetchSubscriptionRequest.type, fetchSubscriptionSaga);
  yield takeLatest(
    manuallyExpireSubscriptionRequest.type,
    manuallyExpireSubscriptionWorker,
  );
  yield takeLatest(payInstallmentRequest.type, payInstallmentWorker);
  yield takeLatest(
    fetchChildSubscriptionRequest.type,
    fetchChildSubscriptionWorker,
  );
  yield takeLatest(payExternalFeaturesRequest.type, payExternalFeaturesWorker);
  yield takeLatest(
    fetchExternalSubscriptionRequest.type,
    fetchExternalSubscriptionWorker,
  );
  yield takeLatest(
    updateBenefitAndFeatureRequest.type,
    updateBenefitAndFeatureWorker,
  );
}
